// @ts-strict-ignore
import React, { ChangeEvent, SetStateAction, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Input, Tooltip } from '@node-space/ui-components'
import { ApprovalRulesData } from 'types/approvals'
import { stringToDecimal } from 'utils/utils'
import { useApprovalRangeConfig } from './hooks/useApprovalRangeSettings'

interface ApprovalFromToRangeProps {
  rangeValues: { minAmount: number; maxAmount: string | number }
  rowIndex: number
  handleInputChange: (index: number, event: ChangeEvent<HTMLInputElement>) => void
  approvalRulesData: ApprovalRulesData[]
  postLabel: string
  isApprovalRuleInvalid: boolean
  setIsApprovalRuleInvalid?: (value: SetStateAction<boolean>) => void
}

const ApprovalFromToRange = ({
  rangeValues,
  rowIndex,
  handleInputChange,
  approvalRulesData,
  postLabel,
  isApprovalRuleInvalid,
  setIsApprovalRuleInvalid,
}: ApprovalFromToRangeProps) => {
  const { t } = useTranslation()

  const { prefillFromValue, toInputIsDisabled, currentRowToValue, isCurrentRowRangeInvalid } =
    useApprovalRangeConfig(approvalRulesData, rowIndex)

  const currentToValueHasError = !!currentRowToValue && isCurrentRowRangeInvalid

  const onChangeToField = (rowIndex: number, e: ChangeEvent<HTMLInputElement>) => {
    approvalRulesData[rowIndex].maxAmount = stringToDecimal(e?.target?.value)
  }

  useEffect(() => {
    if (currentToValueHasError) {
      setIsApprovalRuleInvalid(currentToValueHasError)
    }
  }, [rowIndex, isApprovalRuleInvalid, currentToValueHasError])

  return (
    <Box flex gapX={8} width="full">
      <Input
        testId="approval-range-from-input"
        inputMode="numeric"
        label={t('from')}
        disabled
        rightSuffixText={postLabel}
        value={prefillFromValue}
      />
      <Input
        testId="approval-range-to-input"
        inputMode="numeric"
        label={t('to')}
        value={rangeValues?.maxAmount?.toString() || ''}
        disabled={toInputIsDisabled}
        onChange={e => {
          onChangeToField(rowIndex, e)
          handleInputChange(rowIndex, e)
        }}
        rightSuffixText={postLabel}
        {...(currentToValueHasError && {
          error: true,
          Tooltip: (
            <Tooltip
              bodyContent={t('approvals.addNewRowIsDisabledError')}
              type="complex"
              position="top"
            />
          ),
        })}
      />
    </Box>
  )
}

export default ApprovalFromToRange
